export const moneyFormat = (
  sum?: number,
  withText = true,
  locale: 'ru' | 'en' = 'ru'
) => {
  if (!sum) return

  const money = sum.toLocaleString(locale === 'ru' ? 'ru-RU' : 'en-US')

  if (withText) {
    return `${money} ${locale === 'ru' ? 'руб.' : 'usd'}`
  }

  return money
}
